/* eslint-disable no-param-reassign */
import produce from 'immer';
import { SET_ALL_DISPATCH_STATUS_AND_STATE_MAPPINGS } from 'src/actions/dispatchStatusAndStateMapping';

const initialState = {
  dispatchStatusAndStateMapping: null,
};

// eslint-disable-next-line default-param-last
const dispatchStatusStateMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_DISPATCH_STATUS_AND_STATE_MAPPINGS: {
      let allDispatchStatusAndStateMappings;
      if (action.payload?.allDispatchStatusAndStateMappings) {
        allDispatchStatusAndStateMappings = action.payload.allDispatchStatusAndStateMappings;
      } else if (action.payload) {
        allDispatchStatusAndStateMappings = action.payload;
      } else {
        allDispatchStatusAndStateMappings = [];
      }
      return produce(state, (draft) => {
        draft.dispatchStatusAndStateMapping = allDispatchStatusAndStateMappings;
      });
    }
    default: {
      return state;
    }
  }
};

export default dispatchStatusStateMappingReducer;
